const constants = {
    buttonTypes: {
        accept: 'accept' as const,
        cancel: 'cancel' as const,
        close: 'close' as const,
        delete: 'delete' as const,
        recover: 'recover' as const,
        save: 'save' as const,
        unsubscribe: 'unsubscribe' as const,
        download: 'download' as const,
        component: 'component' as const,
    },
    orgt: {
        scIds: [3444, 2401],
        taxCodes: {
            feePassCode: 'CW',
            feeRoomActivity: 'AJ',
            feeAquaticActivity: 'CS',
            enrollment: 'SM',
            athleticismFee: 'E2',
            summerFees: 'PP',
            facilityRental: 'E1',
            noOption: null,
        },
    },
    payment: {
        privileges: {
            pay: 'pay',
            recover: 'recover',
            delete: 'delete',
            refund: 'refund',
            refundTPV: 'refundTPV',
            modify: 'modify',
        },
        paymentStatus: [
            { caption: 'ERROR', value: 'ERROR' },
            { caption: 'CREATING', value: 'CREATING' },
            { caption: 'PAID', value: 'PAID' },
            { caption: 'PAYING', value: 'PAYING' },
            { caption: 'PENDING', value: 'NOT_PAID' },
            { caption: 'ALL', value: 'ALL' },
        ],
        pendingPaymentForm: '', // Debido al cambio reciente en backend, ahora pendiente no es 'LATER', es '', pero '' no
        // puede indexar por tipo en el resto de la plataforma, donde se ha tenido en cuenta el cambio 'LATER' -> ''
        paymentForms: {
            dataphone: {
                name: 'DATAFONO',
                translationCode: 'payment.paymentFormDataphone',
            },
            dataphoneConnected: {
                name: 'DATAFONO_CONNECTED',
                translationCode: 'payment.paymentFormDataphoneConnected',
            },
            cash: {
                name: 'CASH',
                translationCode: 'payment.paymentFormCash',
            },
            purse: {
                name: 'PURSE',
                translationCode: 'payment.paymentFormPurse',
            },
            tpv: {
                name: 'TPV',
                translationCode: 'payment.paymentFormTpv',
            },
            later: {
                name: 'LATER',
                translationCode: 'payment.paymentFormLater',
            },
            bank: {
                name: 'BANK',
                translationCode: 'payment.paymentFormBank',
            },
            free: {
                name: 'FREE',
                translationCode: 'payment.paymentFormFree',
            },
            receipt: {
                name: 'RECEIPT',
                translationCode: 'payment.paymentFormReceipt',
            },
            zitycard: {
                name: 'ZITYCARD',
                translationCode: 'payment.paymentFormZitycard',
            },
            cashdro: {
                name: 'CASHDRO',
                translationCode: 'payment.paymentFormCashdro',
            },
        },
        status: {
            paid: {
                name: 'PAID',
                translationCode: 'payment.statusPaid',
            },
            notPaid: {
                name: 'NOT_PAID',
            },
        },
        currency: {
            EUR: 'EUR',
        },
    },
    modules: {
        renting: {
            name: 'RENTING',
            translationCode: 'module.renting',
        },
        event: {
            name: 'EVENT',
            translationCode: 'module.event',
        },
        class: {
            name: 'CLASS',
            translationCode: 'module.class',
        },
        game: {
            name: 'GAME',
            translationCode: 'module.game',
        },
        abonados: {
            name: 'ABONADOS',
            translationCode: 'module.abonados',
        },
        purse: {
            name: 'PURSE',
            translationCode: 'module.purse',
        },
    },
    mship: {
        status: {
            active: 'active',
            inactive: 'inactive',
        },
    },
    sporttiaConfigurations: {
        logLevels: ['error', 'warn', 'info', 'http', 'debug'],
    },
    rate: {
        types: {
            individual: 1,
            complete: 2,
        },
    },
    roles: {
        sportcenter: 'SPORTCENTER',
        admin: 'ADMIN',
    },
    regexp: {
        datetime: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/,
        datetimeISO8601:
            /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(\.\d{3})?(Z|[+-]\d{2}:\d{2})?$/,
        date: /^\d{4}-\d{2}-\d{2}$/,
    },
    unlocker: {
        types: {
            card: 'CARD',
            PIN: 'PIN',
            QR: 'QR',
            noUnlocker: 'NULL',
        },
    },
    group: {
        types: {
            sport: {
                name: 'SPORT',
                translationCode: 'group.typeSport',
            },
            normal: {
                name: 'NORMAL',
                translationCode: 'group.typeNormal',
            },
            abonados: {
                name: 'ABONADOS',
                translationCode: 'group.typeAbonados',
            },
            family: {
                name: 'FAMILY',
                translationCode: 'group.typeFamily',
            },
        },
    },
    appStores: {
        play: {
            link: 'https://play.google.com/store/apps/details?id=com.sporttia.app',
        },
        apple: {
            link: 'https://apps.apple.com/es/app/sporttia-reserva-tu-deporte/id6744922343',
        },
    },
    // Documentación online del panel de gestión (manual del gestor), servida
    // desde el repositorio sporttia-help.
    docs: {
        link: 'https://help.sporttia.com',
    },
    tpvConf: {
        modes: {
            develop: {
                name: 'DEVELOP',
                translationCode: 'IT.DEVELOPMENT',
            },
            production: {
                name: 'PRODUCTION',
                translationCode: 'IT.PRODUCTION',
            },
        },
        banks: {
            stripe: {
                name: 'STRIPE',
            },
            zitycard: {
                name: 'ZITYCARD',
            },
            redsys: {
                name: 'REDSYS_HMAC256',
            },
            ccm: {
                name: 'CCM',
            },
            paycomet: {
                name: 'PAYCOMET',
            },
        },
        /** Relación centro -→ TpvConf (De momento solo en algunos tpv confs) */
        banksWithManyCenters: ['ZITYCARD'],
    },
    tpv: {
        results: {
            errorPurse: 'RESULT_ERROR_PURSE',
        },
    },
    events: {
        types: {
            tournament: 'TOURNAMENT',
            normal: 'NORMAL',
        },
    },
    gui: {
        objectState: {
            create: 'create',
        },
    },
    activity: {
        status: {
            closed: 'CLOSE',
        },
    },
    bono: {
        bonoExpirationDefault: '0000-00-00 00:00:00',
    },
    report: {
        status: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE',
        },
    },
    cashdro: {
        op: {
            SALE: 4,
            REFUND: 5,
            CANCEL_WITHDRAWAL: 6,
            EXCUTE_WITHDRAWAL: 1, // Execute withdrawal operation type
        },
    },
    fileTypes: [
        {
            id: 'Q60_MOD_2',
            label: 'Q60_MOD_2',
            color: '#3982d0',
        },
        {
            id: 'user_import',
            translationCode: 'fileType.userImport',
            color: '#9b59b6',
        },
        {
            id: 'facility',
            translationCode: 'fileType.facility',
            color: '#3498db',
        },
        {
            id: 'sc',
            translationCode: 'fileType.sc',
            color: '#2ecc71',
        },
        {
            id: 'activity',
            translationCode: 'fileType.activity',
            color: '#1abc9c',
        },
        {
            id: 'user_photo',
            translationCode: 'fileType.userPhoto',
            color: '#e67e22',
        },
        {
            id: 'event_doc',
            translationCode: 'fileType.eventDoc',
            color: '#f1c40f',
        },
    ],
    disabledApi: {
        message: {
            es: 'Estamos teniendo problemas para conectar con la aplicación. Comprueba tu conexión a internet e inténtalo de nuevo más tarde.',
            ca: "Estem tenint problemes per connectar amb l'aplicació. Comprova la teva connexió a internet i torna-ho a intentar més tard.",
            cl: 'Estamos teniendo problemas para conectar con la aplicación. Comprueba tu conexión a internet e inténtalo de nuevo más tarde.',
            en: "We're having trouble connecting to the app. Please check your internet connection and try again later.",
            fr: "Nous rencontrons des problèmes de connexion à l'application. Vérifie ta connexion internet et réessaie plus tard.",
            de: 'Es gibt ein Verbindungsproblem mit der App. Bitte überprüfe deine Internetverbindung und versuche es später erneut.',
            gl: 'Estamos tendo problemas para conectar coa aplicación. Comproba a túa conexión a internet e téntao de novo máis tarde.',
            mx: 'Estamos teniendo problemas para conectar con la aplicación. Comprueba tu conexión a internet e inténtalo de nuevo más tarde.',
            pt: 'Estamos tendo problemas para conectar com o aplicativo. Verifique sua conexão com a internet e tente novamente mais tarde.',
        },
        title: {
            es: 'Sin conexión con el servidor',
            ca: 'Sense connexió amb el servidor',
            cl: 'Sin conexión con el servidor',
            en: 'No connection to the server',
            fr: 'Pas de connexion au serveur',
            de: 'Keine Verbindung zum Server',
            gl: 'Sen conexión co servidor',
            mx: 'Sin conexión con el servidor',
            pt: 'Sem conexão com o servidor',
        },
        reload: {
            es: 'Recargar',
            ca: 'Tornar a carregar',
            cl: 'Recargar',
            en: 'Reload',
            fr: 'Recharger',
            de: 'Neu laden',
            gl: 'Recargar',
            mx: 'Recargar',
            pt: 'Recarregar',
        },
    },
    boundedContextPrefixes: {
        MANAGER: '/manager',
        COMMUNICATIONS: '/communications',
    },
} as const;

export default constants;
